import React from 'react';
import { Box, Text } from 'grommet';
import SHDGradient from '@ui/Gradient/SHDGradient';
import SHDText from '@ui/Text/SHDText';
import SHDButton from '@ui/Button/SHDButton';
import SHDImage from '@ui/Image/SHDImage';
import * as ROUTES from '@constants/routes';
import { PaywallCtaCopy } from '../paywall.types';

interface PaywallAccessUpsellProps {
  onClick: () => void;
  isLoggedIn: boolean;
  isClaimed: boolean;
  customCopy: PaywallCtaCopy | null;
}

const PaywallAccessUpsell: React.FC<PaywallAccessUpsellProps> = ({
  onClick,
  isLoggedIn,
  customCopy,
}) => {
  return (
    <Box
      style={{ position: 'relative' }}
      height="auto"
      align="center"
      pad="large"
      gap="medium"
    >
      <SHDGradient direction="180deg" variant="gray">
        <Box gap="small" align="center">
          <SHDImage src="/paywall/pro.svg" alt="PRO" width="auto" />
          <Text
            style={{
              color: '#000',
              textAlign: 'center',
              fontFamily: 'Messina Sans',
              fontSize: '24px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '28px',
            }}
          >
            {customCopy ? (
              customCopy.headline
            ) : (
              <>
                Unlock full access to
                <br />
                all player highlights and
                <br />
                play-by-play clips.
              </>
            )}
          </Text>
          <SHDText style="body" color="gray" textAlign="center">
            Only $5.99/month. Cancel anytime.
          </SHDText>
          <Box style={{ width: 176 }}>
            <SHDButton
              label="Unlock access"
              primary
              onClick={() => {
                !isLoggedIn
                  ? window.location.replace(
                      `${ROUTES.SIGN_IN}?redirectUrl=${window.location.pathname.replace('/', '')}`
                    )
                  : onClick();
              }}
            />
          </Box>
          {!isLoggedIn && (
            <SHDText style="body" color="gray" textAlign="center">
              or{' '}
              <a
                href={`${ROUTES.SIGN_IN}?redirectUrl=${window.location.pathname.replace('/', '')}`}
                style={{
                  fontWeight: '600',
                  color: 'green',
                  textDecorationLine: 'none',
                }}
              >
                Sign in
              </a>{' '}
              to view profile.
            </SHDText>
          )}
        </Box>
      </SHDGradient>
    </Box>
  );
};

export default PaywallAccessUpsell;
